import _ from 'lodash';
import { connect } from 'react-redux';
import { add, get } from '../../modules/ocr/ocrGuideDocument';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	const ocrGuideDocumentId = _.get(ownProps, ['match', 'params', 'ocrGuideDocumentId']);
	const ocrGuideDocument = ocrGuideDocumentId
		? _.get(state.maps, ['ocrGuideDocument', ocrGuideDocumentId])
		: undefined;

	return {
		ocrGuideDocument,
		ocrGuideDocumentMap: state.maps.ocrGuideDocument,
		resourceMap: state.maps.resource,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			ocrGuideDocumentAdd: add,
			ocrGuideDocumentGet: get,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
